// export const CIRO_URL = "http://localhost:8080";
export const CIRO_URL = "https://emaarciro-x5efbak6ja-ew.a.run.app";
export const KDV = 100 / 110;

export enum ReportStatus {
  Loading = "LOADING",
  Pending = "PENDING",
  Reported = "REPORTED",
  Error = "ERROR",
}
